import { editorConfig } from '~config';
import { getState, getStatePure, modifyState } from '~src/state';
import { highlightCurrentPage } from '~src/multipages';
import { applyOrgLogosOnCurrentPage } from '~src/sidebar/logo';
import { setProfilePhotoToAllMagicFrames } from '~src/utils';
import { replaceImageUrlsWithImage } from '~core';
import { convertTextboxesToSpellCheck } from '~core/spellcheck';

export const goToPage = (pageIndex) => {
  return new Promise((resolve) => {
    if (!getState('isChangingPage')) {
      modifyState('isChangingPage', true);
      const oldPageIndex = getState('currentPageIndex');
      const currentPageJson = JSON.stringify(
        window.canvas.toJSON(editorConfig.additionalJsonProperties)
      );
      modifyState('currentPageIndex', pageIndex);
      modifyState(`pages[${oldPageIndex}].canvasJson`, currentPageJson).then(
        () => {
          const pages = getStatePure('pages');

          // Check if pageIndex is valid
          if (!pages[pageIndex]) {
            console.error(
              `Invalid page index: ${pageIndex}. Total pages: ${pages.length}`
            );
            modifyState('isChangingPage', false);
            resolve();
            return;
          }

          const { canvasJson } = pages[pageIndex];

          window.canvas.loadFromJSON(canvasJson, async () => {
            await convertTextboxesToSpellCheck(window.canvas);

            applyOrgLogosOnCurrentPage();
            modifyState('undoInProgress', false);
            await setProfilePhotoToAllMagicFrames();
            await replaceImageUrlsWithImage();
            window.canvas.renderAll();
            highlightCurrentPage();
            modifyState('isChangingPage', false);
            resolve();
          });
        }
      );
    }
  });
};
